module.exports = __webpack_public_path__ + "ac8774dae8990dc268c448b8eaf1d95a.jpg";